import axios from 'axios'

axios.defaults.baseURL = 'https://juicer.onrender.com/api/';